<template><div><h1 id="umsatz-nach-projekten-ereignissen-persongruppen" tabindex="-1"><a class="header-anchor" href="#umsatz-nach-projekten-ereignissen-persongruppen"><span>Umsatz nach Projekten, Ereignissen, Persongruppen</span></a></h1>
<p>Umsatz nach Projekten, Ereignissen, Persongruppen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Pfad: <code v-pre>Personen → Auswertungen → Umsatz nach Projekten, Ereignissen, Personengruppen</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Projektgruppe</dt>
<dd>Eine oder mehrere, mit Komma trennen, leer = alle</dd>
<dt>Projekte</dt>
<dd>Eines oder mehrere, mit Komma trennen, leer = alle</dd>
<dt>Umsatztypen</dt>
<dd>Ein oder mehrere, mit Komma trennen, leer = alle</dd>
<dt>Ereignistypen</dt>
<dd>Ein oder mehrere, mit Komma trennen, leer = alle</dd>
<dt>Ereignisse</dt>
<dd>Eines oder mehrere, mit Komma trennen, leer = alle</dd>
<dt>Gültigkeitsdatum von</dt>
<dd>[Initialdatum im Ereigniskopf] inklusive, leer = unbegrenzt.<br>Dient dem Ausschluss von Ereignissen, deren Initialdatum nicht im eingegebenen Zeitraum liegt. Muss normalerweise nicht eingegeben zu werden.</dd>
<dt>Gültigkeitsdatum bis</dt>
<dd>[Initialdatum im Ereigniskopf] inklusive, leer = unbegrenzt</dd>
<dt>Nur Bewegungen von</dt>
<dd>Nur Werte aus Responseereignis-Verknüpfungen von..., inklusive, leer = unbegrenzt<br>Schränkt den Zeitraum ein, aus dem die Ereignisse ausgewertet werden.</dd>
<dt>Nur Bewegungen bis</dt>
<dd>Nur Werte aus Responseereignis-Verknüpfungen bis..., inklusive, leer = unbegrenzt</dd>
<dt>Nur Umsätze von Adressen in Filter</dt>
<dd>Adressfilter-Nummer eingeben, 0 = unbegrenzt</dd>
<dt>Output inkl. Ereignispositionen</dt>
<dd>Mit allen Positionen zu jedem Ereignis? ja/nein</dd>
<dt>Output inkl. Ereignisse ohne U</dt>
<dd>Output listet auch Ereignisse ohne Umsatz auf? ja/nein</dd>
<dt>Export-Format (Excel / Text)</dt>
<dd>Tab-delimited (Excel) bzw. Semikolon-delimited (Text)</dd>
<dt>Ausgabe</dt>
<dd>Standard Tab-delimited (Excel) bzw. Semikolon-delimited (Text)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Projektgruppennummer</td>
<td></td>
</tr>
<tr>
<td>Projektgruppenbezeichnung</td>
<td></td>
</tr>
<tr>
<td>Projektnummer</td>
<td></td>
</tr>
<tr>
<td>Projektbezeichnung</td>
<td></td>
</tr>
<tr>
<td>Ereignisnummer</td>
<td></td>
</tr>
<tr>
<td>Ereignisbezeichnung</td>
<td></td>
</tr>
<tr>
<td>Ereignissituation</td>
<td></td>
</tr>
<tr>
<td>Ereignistyp</td>
<td></td>
</tr>
<tr>
<td>Ereignis-Güligkeitsdatum</td>
<td></td>
</tr>
<tr>
<td>Ereignis-Umsatztyp</td>
<td></td>
</tr>
<tr>
<td>Ereignis-Initialzahl</td>
<td></td>
</tr>
<tr>
<td>Ereignis-Responsezahl</td>
<td></td>
</tr>
<tr>
<td>Ereignis-Gesamtwert</td>
<td></td>
</tr>
<tr>
<td>Ereignisposition-Nummer</td>
<td>(nur mit Option Output inklusive Ereignispositionen)</td>
</tr>
<tr>
<td>Ereignisposition-Bezeichnung</td>
<td></td>
</tr>
<tr>
<td>Ereignisposition-Initialzahl</td>
<td></td>
</tr>
<tr>
<td>Ereignisposition-Responsezahl</td>
<td></td>
</tr>
<tr>
<td>Ereignisposition-Wert</td>
<td></td>
</tr>
</tbody>
</table>
<p>Beispiel Datenausgabe Textdatei mit Semikolon:</p>
<p>Projektgruppennummer;Projektgruppenbezeichnung;Projektnummer;Projektbezeichnung;Ereignisnummer;Ereignisbezeichnung;Ereignissituation;Ereignistyp;Ereignis-Gültigkeitsdatum;Ereignis-Umsatztyp;Ereignis-Initialzahl;Ereignis-Responsezahl;Ereignis-Gesamtwert;
;;;;7044;Beilage Mitgliederwerbung 1998;RWV;K;;wah;10000;00;00.0;
;;;;7082;Prospekt Beilage Jahresbericht 1997;RWV;K;;wah;36100;00;00.0;
;;;;7137;Sommerboten 1998;RWV;K;;wah;74000;00;00.0;
;;;;7146;Kalenderprospekt Kalender 1999;RWV;K;;wah;634100;00;00.0;
.
.</p>
<p>Für die Beilage Mitgliederwerbung 1998 wurden 10'000 Initialereignisse verzeichnet, aber noch keine Responsewerte.</p>
</div></template>


